const SYNC_INTERVAL_MS = 24 * 60 * 60 * 1000;

export const getSubscriptionStorageKey = (companyId: number): string =>
  `sub_${companyId}`;

export const getSubscriptionSyncStorageKey = (companyId: number): string =>
  `sub_sync_${companyId}`;

export const markPushSubscriptionSynced = (companyId: number): void => {
  localStorage.setItem(getSubscriptionSyncStorageKey(companyId), String(Date.now()));
};

export const isDevelopmentEnvironment = (): boolean =>
  process.env.NODE_ENV === "development" ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const isPushSubscriptionEnabled = (companyId: number): boolean =>
  localStorage.getItem(getSubscriptionStorageKey(companyId)) === "enabled";

export const shouldSyncPushSubscription = (companyId: number): boolean => {
  const lastSync = localStorage.getItem(getSubscriptionSyncStorageKey(companyId));
  if (!lastSync) {
    return true;
  }

  const lastSyncTime = Number(lastSync);
  if (Number.isNaN(lastSyncTime)) {
    return true;
  }

  return Date.now() - lastSyncTime >= SYNC_INTERVAL_MS;
};

export const sendPushSubscriptionToBackend = async (
  companyId: number,
  subscription: PushSubscription,
  token?: string | null,
): Promise<Response> => {
  const authToken = token ?? localStorage.getItem("p_menu_token");

  return fetch(`/api/company/${companyId}/subscribe/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      subscription: subscription.toJSON(),
      userAgent: navigator.userAgent,
    }),
  });
};

export const syncPushSubscription = async (companyId: number): Promise<void> => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const response = await sendPushSubscriptionToBackend(companyId, subscription);
      if (response.ok) {
        markPushSubscriptionSynced(companyId);
      }
      return;
    }
  } catch (error) {
    console.error("Push subscription sync failed:", error);
  }
};
